export default __webpack_public_path__ + "static/media/w_wdt_c_1.d4237d5d.mp3";